import React from 'react';
import { Flex, Text, Divider } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/pro-regular-svg-icons';
import { IPeerReviewListItemWithRescission } from '@publishing-engine/domain/views/review';
import FileViewerButtonText from '../FileViewerButtonText';

interface Props {
  review: IPeerReviewListItemWithRescission;
  submissionContextId?: string;
}

const RescindReview: React.FC<Props> = ({ review, submissionContextId }) => {
  const { feedback, attachments } = review.caseData.firstAssessmentRescission;

  return (
    <Flex
      gap={8}
      background="whiteSecondaryFill"
      flexDirection="column"
      marginY={4}
    >
      <Flex flexDirection="column" gap={2}>
        <Text textStyle="headingItem">Feedback to Reviewer:</Text>
        <Text textStyle="textBody">{feedback}</Text>
      </Flex>

      {attachments.length > 0 && (
        <Flex flexDirection="column" gap={4}>
          <Text textStyle="headingItem">Attachments</Text>
          <Flex flexDirection="column" gap={4} marginTop={4}>
            {attachments.map((attachment, index) => (
              <React.Fragment key={attachment.id}>
                <Flex justifyContent="space-between">
                  <Flex gap={2} alignItems="center">
                    <FontAwesomeIcon icon={faFile} />
                    <Text textStyle="textBody">{attachment.name}</Text>
                    <FileViewerButtonText
                      file={attachment}
                      submissionContextId={submissionContextId}
                    >
                      View
                    </FileViewerButtonText>
                  </Flex>
                </Flex>
                {index < attachments.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};

export default RescindReview;
